import template from './createCustomer.html';
import controller from './createCustomer.controller';

let createCustomerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default createCustomerComponent;



// WEBPACK FOOTER //
// ./app/components/createCustomer/createCustomer.component.js